<template>
  <background-video />

  <sheet-modal  v-model="modals.confirmModal" exact-width="w-[423px]"
                scrollable icon="check-circle" :title="heading" :subtitle="text"
                blocking :has-confirm="!!purchasingPlanCode">
    <account-profile v-if="confirmSuccess && !purchasingPlanCode" />
  </sheet-modal>

  <sheet-modal v-model="modals.languagePickerModal" :title="$t('languagepicker_title')" exact-width="w-[400px]" blocking>
    <language-picker :initial="user.language" @select="updateUserLanguage"></language-picker>
  </sheet-modal>

  <main-footer></main-footer>
</template>

<script>
// @ is an alias to /src
import ProductService from "@/services/products.service";
import {mapMutations, mapState} from "vuex";
import SheetModal from "@/components/ui/SheetModal.vue";
import BackgroundVideo from "@/components/ui/BackgroundVideo.vue";
import AccountProfile from "@/components/account/AccountProfile.vue";
import MainFooter from "@/components/MainFooter.vue";
import LanguagePicker from "@/components/session/LanguagePicker.vue";
import emitter from "@/services/emitter.service";

export default {
  name: 'PaymentSuccess',
  components: {
    LanguagePicker, MainFooter, AccountProfile, BackgroundVideo, SheetModal

  },
  data() {
    return {
      confirmSuccess: false,
      modals: {
        confirmModal: false,
        languagePickerModal: false,
      }
    }
  },
  methods: {
    ...mapMutations('nonpersist', ['setUserLanguage']),
    showModal(modalName) {
      this.modals[modalName] = true;
    },
    updateUserLanguage(language) {
      this.setUserLanguage(language);
      this.showModal('confirmModal');
      console.log(this.modals)
    },
  },
  computed: {
    ...mapState('auth', ['token', 'purchaseType', 'purchasingPlanCode', 'purchaseInitiated', 'authorized']),
    ...mapState('nonpersist', ['user']),
    heading: function () {
      let title = this.$t('pro_plan_activated');
      if (this.purchaseType && this.purchaseType === 'consumable') {
        title = this.$t('thank_for_purchase');
      }

      return title;
    },
    text: function () {
      return this.$t('profile_account_activated_text');
    }
  },
  mounted() {
    const session_id = this.$route.query.session_id;
    if (session_id) {
      ProductService.verifyOrder(session_id).then(() => {
        this.modals.confirmModal = true;
        this.confirmSuccess = true;
      }).catch(() => {

      })
    }

    emitter.on('open-language-picker-popup', () => {
      this.showModal('languagePickerModal');
    });
  }
}
</script>

<style lang="scss" scoped>
// Define vars we'll be using
$brand-success: #5cb85c;
$loader-size: 7em;
$check-height: $loader-size/2;
$check-width: $check-height/2;
$check-left: ($loader-size/6 + $loader-size/12);
$check-thickness: 3px;
$check-color: $brand-success;

  .page-wrapper {
    padding-top: 5rem;
    display: flex;
    flex-direction: column;

    &--about {
      justify-content: center;
      align-items: center;
      width: 70%;
      margin: 0 auto;

      img {
        max-width: 57rem;
      }
    }

    .about-text {

      p {
        margin: 30px 0 0;
        text-transform: uppercase;
        font-size: 1.25rem;
        line-height: 1.875rem;
        text-align: center;
        color: #000000;
      }
    }
  }

  .circle-loader {
    margin-bottom: $loader-size/2;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-left-color: $check-color;
    animation: loader-spin 1.2s infinite linear;
    position: relative;
    display: inline-block;
    vertical-align: top;
    border-radius: 50%;
    width: $loader-size;
    height: $loader-size;
  }

  .loadcomplete {
    -webkit-animation: none;
    animation: none;
    border-color: $check-color;
    transition: border 500ms ease-out;
  }

  .checkmark {
    &.draw:after {
      animation-duration: 800ms;
      animation-timing-function: ease;
      animation-name: checkmark;
      transform: scaleX(-1) rotate(135deg);
    }

    &:after {
      opacity: 1;
      height: $check-height;
      width: $check-width;
      transform-origin: left top;
      border-right: $check-thickness solid $check-color;
      border-top: $check-thickness solid $check-color;
      content: '';
      left: $check-left;
      top: $check-height;
      position: absolute;
    }
  }

  @keyframes loader-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes checkmark {
    0% {
      height: 0;
      width: 0;
      opacity: 1;
    }
    20% {
      height: 0;
      width: $check-width;
      opacity: 1;
    }
    40% {
      height: $check-height;
      width: $check-width;
      opacity: 1;
    }
    100% {
      height: $check-height;
      width: $check-width;
      opacity: 1;
    }
  }
</style>
